const LANGUAGE_NAME_BY_CODE: Record<string, string> = {
  en: 'English',
  'en-gb': 'English (United Kingdom)',
  es: 'Spanish',
  'es-mx': 'Spanish (Mexico)',
  fr: 'French',
  'fr-ca': 'French (Canada)',
  de: 'German',
  it: 'Italian',
  'zh-cn': 'Chinese (Simplified)',
  pt: 'Portuguese',
  'pt-br': 'Portuguese (Brazil)',
  ja: 'Japanese',
  ko: 'Korean',
  ru: 'Russian',
  ar: 'Arabic',
  nl: 'Dutch',
  pl: 'Polish',
  tr: 'Turkish',
  sv: 'Swedish',
  da: 'Danish',
  fi: 'Finnish',
  no: 'Norwegian',
  vi: 'Vietnamese',
  th: 'Thai',
  id: 'Indonesian',
  he: 'Hebrew',
  uk: 'Ukrainian',
  cs: 'Czech',
  el: 'Greek',
  ro: 'Romanian',
  hu: 'Hungarian'
}

const mapLanguageCodeToName = (languageCode?: string | null) => {
  if (!languageCode) {
    return ''
  }

  const normalizedCode = languageCode.trim().toLowerCase()
  const baseCode = normalizedCode.split(/[-_]/)[0]

  return LANGUAGE_NAME_BY_CODE[normalizedCode] ?? LANGUAGE_NAME_BY_CODE[baseCode] ?? languageCode.toUpperCase()
}

export default mapLanguageCodeToName
